const LOGO_URL = '/images/logo.png';
const navLinks = ['Home', 'About', 'Offerings'];

export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-[#2C4A3B] py-14 px-8 lg:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 mb-10 items-start">
          <div className="flex items-start gap-4 md:col-span-1">
            <img
              src={LOGO_URL}
              alt="Mastro Family Farm"
              className="h-12 w-12 object-contain rounded-full ring-2 ring-[#C8973A]/40 shrink-0"
            />
            <div>
              <p className="font-serif text-white text-lg font-bold mb-1">
                Mastro Family Farm
              </p>
              <p
                className="text-[#B8C8B8] text-sm leading-relaxed"
                style={{ fontFamily: "'Nunito', sans-serif" }}
              >
                A small, faithful family farm growing food, raising chickens, and tending bees all for the glory of God.
              </p>
            </div>
          </div>

          <div>
            <p className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Explore</p>
            <div className="flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <button
                  key={link}
                  onClick={() => scrollTo(link)}
                  className="text-[#B8C8B8] text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap text-left"
                >
                  {link}
                </button>
              ))}
            </div>
          </div>

          <div>
            <p className="text-white font-semibold text-sm uppercase tracking-wider mb-4">
              A Word
            </p>
            <p
              className="text-[#B8C8B8] text-sm italic leading-relaxed mb-3"
              style={{ fontFamily: "'Dancing Script', cursive", fontSize: '1rem' }}
            >
              &ldquo;Commit your work to the Lord, and your plans will be established.&rdquo;
            </p>
            <p className="text-[#C8973A] text-xs font-medium">&mdash; Proverbs 16:3</p>

            <div className="flex gap-3 mt-6">
              {['ri-facebook-circle-line', 'ri-instagram-line'].map((icon) => (
                <div
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/25 text-white/70 hover:text-white hover:border-white/50 transition-all cursor-pointer"
                >
                  <i className={`${icon} text-base`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/15 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#B8C8B8] text-xs">
            &copy; {new Date().getFullYear()} Mastro Family Farm. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
